import { createUploadUrlsOperation } from "@api/services/storage";

import type { Request } from "./types";

type CreateUploadUrlsOutput = {
  data: {
    urls: string[];
  };
};

const UPLOAD_URLS_QUANTITY = 1;

const CONTENT_TYPE_PLUS = "+";
const CONTENT_TYPE_PLUS_REPLACEMENT = "-";

const createUploadUrl = async (
  request: Request,
  isPublic: boolean,
  contentType: string,
): Promise<string> => {
  const normalizedContentType = contentType.replace(CONTENT_TYPE_PLUS, CONTENT_TYPE_PLUS_REPLACEMENT);

  const parameters = {
    quantity: UPLOAD_URLS_QUANTITY,
    isPublic,
    contentType: normalizedContentType,
  };

  const { data: { urls } } = await request<CreateUploadUrlsOutput>(createUploadUrlsOperation, parameters);
  const [ uploadUrl ] = urls;

  return uploadUrl;
};

export default createUploadUrl;
